import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ImageCompressor from '../../components/ImageCompressor';

const CompressImage: React.FC = () => (
  <ToolLayout
    title="Compress Image Online Free - Reduce File Size | AllTools"
    description="Compress JPG, PNG, WebP images online for free. Reduce file size while maintaining quality. Batch compression supported."
    canonicalPath="/compress-image"
  >
    <ImageCompressor />
  </ToolLayout>
);

export default CompressImage;
